var React = require('react');

function IconEnvelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.2191 0C18.202 0 19 0.830933 19 1.85693V13.0036C19 14.0296 18.202 14.8618 17.2191 14.8618H1.78093C0.798 14.8618 0 14.0296 0 13.0036V1.85693C0 0.830933 0.798 0 1.78093 0H17.2191ZM17.2191 1.85693H1.78093V3.43647C2.61313 4.14327 3.9406 5.24273 6.7754 7.5582C7.39987 8.0712 8.63867 9.3024 9.5 9.28847C10.3613 9.3024 11.5989 8.0712 12.2233 7.5582C13.9005 6.19878 15.5658 4.82481 17.2191 3.43647V1.85693ZM1.78093 13.0036H17.2191V5.8216C15.925 6.89286 14.6266 7.95898 13.3241 9.01993C12.4881 9.70647 11.0846 11.1555 9.5 11.1467C7.90653 11.1555 6.48533 9.68493 5.67467 9.01867C4.37255 7.95769 3.07463 6.89157 1.78093 5.82033V13.0036Z","fill":"currentColor"}));
}

IconEnvelope.defaultProps = {"width":"19","height":"15","viewBox":"0 0 19 15","fill":"none"};

module.exports = IconEnvelope;

IconEnvelope.default = IconEnvelope;
